class ResponseError extends Error {
    public response: any;
    constructor(message: string, res: any) {
        super(message);
        this.response = res;
    }
}

export {ResponseError};